import { ArrowRight } from "lucide-react";

export default function MobileStickyCTA({ onCtaClick }) {
    return (
        <div
            className="md:hidden fixed bottom-0 inset-x-0 z-[55] bg-white/95 backdrop-blur-xl border-t border-slate-200 px-4 py-3 shadow-[0_-8px_24px_-12px_rgba(2,132,199,0.18)]"
            data-testid="mobile-sticky-cta"
            style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
        >
            <button
                onClick={onCtaClick}
                data-testid="mobile-sticky-cta-button"
                className="group w-full inline-flex items-center justify-center gap-2 rounded-full bg-sky-600 hover:bg-sky-700 text-white font-semibold h-12 shadow-lg shadow-sky-600/30 transition-all active:scale-[0.97]"
            >
                Tilmeld launch
                <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
            </button>
        </div>
    );
}
